import * as React from 'react';
import ForgotPassword from '../containers/ForgotPassword';

export default (props) => (<ForgotPassword {...props} />);
